import { Typography } from '@material-ui/core';
import NoImageFound from '../../../../public/Spinner-Logo.gif';

export const QuattrLogoSpinner = ({ classes, text = '' }) => {
  return (
    <>
      <div className={classes.overlay} style={{ zIndex: 9 }}></div>
      <div className={classes.loader} style={{ zIndex: 9 }}>
        <img src={NoImageFound.src} alt="Loading..." />
        {text ? <Typography className={classes.loaderText}>{text}</Typography> : null}
      </div>
    </>
  );
};
